import { defaultThemeVariables } from './default-theme-variables';
import { color, fontFamily } from './variable-constants';

export const salesVmo2ThemeVariables = {
  ...defaultThemeVariables,
  '--primary-color': color.vmBlue,
  '--secondary-color': color.shadowPurple,
  '--tertiary-color': color.vmRed,
  '--primary-shadow': color.shadowBlue,
  '--secondary-shadow': color.shadowRed,
  '--tertiary-shadow': color.shadowRed,

  '--action-primary': color.vmBlue,
  '--action-secondary': color.vmBlue,
  '--action-tertiary': color.vmBlue,
  '--action-primary-shadow': color.shadowBlue,
  '--action-secondary-shadow': color.shadowBlue,
  '--action-tertiary-shadow': color.shadowBlue,

  '--action-button-border-radius': '1rem',

  '--text-h1-font-family': fontFamily.vmAeonikProLight,
  '--text-h1-font-size': '1.875rem',
  '--text-h1-letter-spacing': 0,
  '--text-h1-font-family-md': fontFamily.vmAeonikProLight,
  '--text-h1-font-size-md': '2.5rem',
  '--text-h1-letter-spacing-md': 0,

  '--text-h2-font-family': fontFamily.vmAeonikProBold,
  '--text-h2-font-size': '1.625rem',
  '--text-h2-letter-spacing': 0,
  '--text-h2-font-family-md': fontFamily.vmAeonikProBold,
  '--text-h2-font-size-md': '2.1875rem',
  '--text-h2-letter-spacing-md': 0,

  '--text-h2-secondary-font-family': fontFamily.vmAeonikProRegular,
  '--text-h2-secondary-font-size': '1.3125rem',
  '--text-h2-secondary-font-size-md': '1.875rem',

  '--text-h2-tertiary-font-family': fontFamily.vmAeonikProLight,
  '--text-h2-tertiary-font-size': '1.3125rem',
  '--text-h2-tertiary-font-size-md': '1.875rem',

  '--text-h2-quaternary-font-family': fontFamily.vmAeonikProLight,

  '--text-h3-font-family': fontFamily.vmAeonikProLight,
  '--text-h3-font-size': '1.3125rem',
  '--text-h3-letter-spacing': 0,
  '--text-h3-font-family-md': fontFamily.vmAeonikProLight,
  '--text-h3-font-size-md': '1.875rem',
  '--text-h3-letter-spacing-md': 0,

  '--text-h3-secondary-font-family': fontFamily.vmAeonikProBold,
  '--text-h3-secondary-font-size': '1.25rem',
  '--text-h3-secondary-font-size-md': '1.25rem',

  '--text-h3-tertiary-font-family': fontFamily.vmAeonikProMedium,
  '--text-h3-tertiary-font-size': '1rem',

  '--text-h3-quaternary-font-size-md': '1.5rem',

  '--text-h4-font-family': fontFamily.vmAeonikProMedium,
  '--text-h4-font-size': '1.125rem',
  '--text-h4-letter-spacing': 0,

  '--text-h4-secondary-font-family': fontFamily.vmRobotoLight,
  '--text-h4-secondary-font-size': '1rem',

  '--text-h4-tertiary-font-family': fontFamily.vmRobotoRegular,
  '--text-h4-tertiary-font-size': '1.25rem',
  '--text-h4-quaternary-font-family': fontFamily.vmAeonikProBold,
  '--text-h4-quinary-font-family': fontFamily.vmAeonikProMedium,

  '--text-h5-font-family': fontFamily.vmAeonikProBold,
  '--text-h5-font-size': '1rem',
  '--text-h5-letter-spacing': 0,

  '--text-h5-secondary-font-family': fontFamily.vmAeonikProMedium,

  '--text-h5-tertiary-font-family': fontFamily.vmRobotoRegular,

  '--text-h5-quaternary-font-family': fontFamily.vmAeonikProRegular,

  '--body-font-family': fontFamily.vmRobotoLight,
  '--body-secondary-font-family': fontFamily.vmAeonikProBold,
  '--body-secondary-color': color.black,
  '--body-secondary-font-size': '0.875rem',
  '--body-tertiary-font-size': '1.125rem',
  '--body-tertiary-font-weight': 400,

  '--body-tertiary-font-family': fontFamily.vmAeonikProLight,
  '--body-quaternary-font-family': fontFamily.vmAeonikProRegular,
  '--body-quinary-font-family': fontFamily.vmAeonikProMedium,

  '--body-strong-font-family': fontFamily.vmAeonikProMedium,
  '--body-strong-font-weight': 500,

  '--body-strong-secondary-font-family': fontFamily.vmRobotoRegular,

  '--body-quaternary-font-size': '1rem',

  '--paragraph-font-family': fontFamily.vmAeonikProLight,

  '--list-font-family': fontFamily.vmRobotoLight,
  '--list-font-size': '1rem',
  '--list-font-weight': 'normal',
  '--list-line-height': 1.25,
  '--list-secondary-font-family': fontFamily.vmRobotoRegular,
  '--list-color': color.black,
  '--list-tertiary-font-family': fontFamily.vmRobotoLight,

  '--text-pop-font-family': fontFamily.vmAeonikProRegular,
  '--text-pop-font-size': '2.25rem',
  '--text-pop-line-height': 0.56,

  '--text-pop-secondary-font-size': '2.1875rem',

  '--text-book-font-weight': 'normal',
  '--text-book-font-family': fontFamily.vmRobotoRegular,
  '--text-book-secondary-font-family': fontFamily.vmAeonikProRegular,
  '--text-book-tertiary-font-family': fontFamily.vmRobotoMedium,

  '--text-link-font-weight': 'normal',
  '--text-link-font-family': fontFamily.vmRobotoRegular,
  '--text-link-color': color.vmBlue,
  '--text-link-hover-color': color.navyBlue,

  '--text-bold-font-family': fontFamily.vmAeonikProBold,
  '--text-bold-secondary-font-family': fontFamily.vmRobotoMedium,
  
  '--text-bold-secondary-font-weight': 500,
  '--text-bold-tertiary-font-family': fontFamily.vmRobotoRegular,
  '--text-bold-quaternary-font-family': fontFamily.vmAeonikProMedium,

  '--text-black-font-family': fontFamily.vmAeonikProBlack,

  '--text-accordion-title-bar-font-family': fontFamily.vmRobotoRegular,
  '--text-accordion-title-bar-font-size': '1rem',

  '--text-light-font-family': fontFamily.vmAeonikProLight,

  '--text-light-secondary-font-family': fontFamily.vmRobotoLight,

  '--text-input-font-family': fontFamily.vmRobotoRegular,
  '--text-input-secondary-font-family': fontFamily.vmRobotoRegular,

  '--text-medium-font-family': fontFamily.vmAeonikProBold,

  '--text-banner-title-font-family': fontFamily.vmAeonikProBold,
  '--text-banner-font-family': fontFamily.vmAeonikProBold,

  '--text-h4-banner-title-font-family': fontFamily.vmAeonikProRegular,
  '--color-banner-background-color': color.white,
  '--color-banner-border-color': color.vmBlue,
  '--color-banner-floating-background-color': color.vmRed,
  '--color-banner-floating-color': color.white,
  '--text-h4-banner-description-font-family': fontFamily.vmRobotoLight,
  '--text-h4-banner-description-font-size': '1rem',
  '--color-banner-description-font-color': color.grey80,
  '--footer-background-color': color.black,
  '--color-calendar-border-color': color.vmBlue,
  '--color-toggle-background-color': color.vmBlue,
  '--color-toggle-border-color': color.vmBlue,
  '--color-toggle-hover-background-color': color.shadowBlue,
  '--color-toggle-hover-border-color': color.shadowBlue,
};
